// extracted by mini-css-extract-plugin
export var addressFields = "_mr-0";
export var animationContainer = "_mr-1";
export var footer = "_mr-2";
export var lineItems = "_mr-3";
export var modalContent = "_mr-4";
export var orderName = "_mr-5";
export var strong = "_mr-6";
export var warning = "_mr-7";